/*
 *   File : resources-overview.js
 *   Author : https://evoqins.com
 *   Description : Resource overview page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

//Custom components
import { DownloadButton } from "../../../Component/Buttons";
import { DataTableComponent } from "../../../Component/DataTable";
import { APIService } from "../../../Service";
import { Loader } from "../../../Component/Others";
import { EmptyScreen } from "../../../Component/EmptyComponent";

const ITEMS_PER_PAGE = 20;

const ResourceOverview = () => {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [adminType, setAdminType] = useState(Cookies.get("admin_type") === "1" ? "super_admin" : "country_admin");

    const [currentPage, setCurrentPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [overviewData, setOverviewData] = useState({});
    const [downloadLoader, setDownloadLoader] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (state !== null) {
            _getOverviewData();
        } else {
            navigate("/manage-training");
        }
    }, [state, currentPage]);

    // handle paginate store list 
    const _handlePageChange = (page_num) => {
        setCurrentPage(page_num);
        setLoader(true);

        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    };

    // store list table 
    const TABLE_COLUMNS = [
        {
            name: 'User name',
            selector: row => row.user_name || '-',
            cell: row => <>{row.user_name}</>,
            width: "280px",
            sortable: true
        },
        {
            name: 'Enrolled on',
            selector: row => row.enrolled_on || "-",
            cell: row => <>{row.enrolled_on || "-"}</>,
            format: row => row.enrolled_on,
            width: "120px",
            sortable: true
        },
        {
            name: 'Progress',
            selector: row => row.progress || "-",
            width: "110px",
            sortable: true
        },
        {
            name: 'Status',
            selector: row => row.status || "-",
            cell: row =>
                <div className={`${row.status.toLowerCase() === "completed" ? "e-text-philippine-green" : "e-text-brilliant-blue "} e-font-weight-500 e-font-14`}>
                    {row.status || "-"}
                </div>,

            width: "130px"
        },
        {
            name: 'Quiz score',
            selector: row => row.quiz_score || "-",
            width: "120px"
        },
        {
            name: 'Training reward',
            selector: row => row.training_reward || "-",
            width: "140px"
        },
    ];


    // API - Enable disable  
    const _getOverviewData = () => {

        let is_post = true;
        let url = adminType === "super_admin" ? 'course/enrolled-users' : 'CA/course/enrolled-users';
        let data = {
            "page_num": currentPage,
            "limit": ITEMS_PER_PAGE,
            "course_id": state.course_id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setOverviewData(response.data);
            } else {
                setOverviewData({});
            }
            setLoader(false);
        });
    };

    // API - Download data
    const _download = () => {
        setDownloadLoader(true);

        let is_post = true;
        let url = adminType === "super_admin" ? 'course/enrolled-users/download' : 'CA/course/enrolled-users/download';
        let data = {
            "course_id": state.course_id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                const url = response.data.download_url;
                const link = document.createElement('a');
                link.href = url;
                link.download = '';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setDownloadLoader(false);
        });
    };


    return (
        <section className='pb-5 '>
            <div className={`${adminType === "super_admin" ? 'e-bg-azureish-white' : 'e-bg-lavender-blush-light'} padding-12px-top padding-98px-bottom padding-52px-lr`}>
                <div className='e-display-flex cursor-pointer w-max-content'
                    onClick={() => navigate("/manage-training")}>
                    <img src={require("../../../Assets/Image/CountryAdmin/arrow-left.svg").default}
                        draggable={false}
                        className='cursor-pointer'
                        alt='arrow' />
                    <h1 className='ps-1 mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                        Overview
                    </h1>
                </div>
            </div>
            <div className='margin-neg-66px-top padding-52px-lr'>
                <div className='e-bg-white e-border-1px-platinum-dark e-admin-box-shadow py-4 e-border-radius-16'>
                    <div className='px-3'>
                        <div className='pb-4 d-flex align-items-center justify-content-end'>
                            <DownloadButton loader={downloadLoader}
                                disabled={loader || Object.keys(overviewData).length === 0 || overviewData.data.length === 0}
                                onClick={_download} />
                        </div>
                    </div>

                    {loader ?
                        <Loader />
                        :
                        Object.keys(overviewData).length !== 0 && overviewData.data.length !== 0 ?
                            <div className={`e-table no-strip no-hover`}>
                                <DataTableComponent columns={TABLE_COLUMNS}
                                    pagination={true}
                                    data={overviewData.data}
                                    paginationPerPage={ITEMS_PER_PAGE}
                                    paginationServer={true}
                                    paginationTotalRows={overviewData.total_count}
                                    paginationDefaultPage={currentPage}
                                    onChangePage={_handlePageChange} />
                            </div>
                            :
                            <div className='h-100vh pt-5 mt-5'>
                                <EmptyScreen message="No data found" />
                            </div>

                    }

                </div>
            </div>
        </section>
    )
}

export default ResourceOverview;
